<ng-container *ngIf="hasOpenStatus; else hasOngoingOrOverdueStatus">
  <ng-container *ngIf="invoicesByDate.invoices[0].sliceDetail">
    <div class="rs-flex-row">
      <div class="rs-flex-column">
        <p class="rs-txt-details rs-padding-bottom1" data-cy="instalment">
          {{
            'bills.redesign.overview.balanceCard.sliceNumberDescription'
              | translate
          }}
          <strong>{{ invoicesByDate.invoices[0].sliceDetail[0].number }}</strong
          >/{{ sliceDetailsNumber }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-font-pxB rs-padding-bottom1">
          <px-currency-amount
            [amount]="invoicesByDate.invoices[0].sliceDetail[0].amount"
          ></px-currency-amount>
        </p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngFor="let invoice of invoicesByDate.invoices">
    <div class="rs-flex-row">
      <div class="rs-flex-column">
        <p class="rs-txt-details rs-padding-bottom1">
          {{ invoice.invoiceTypeTranslation }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-font-pxB rs-padding-bottom1">
          <px-currency-amount
            *ngIf="invoice.sliceDetail"
            [amount]="invoice.totalAmount"
          ></px-currency-amount>
          <px-currency-amount
            *ngIf="!invoice.sliceDetail"
            [amount]="invoice.amount"
          ></px-currency-amount>
        </p>
      </div>
    </div>
    <div class="rs-me"></div>
  </ng-container>
</ng-container>

<ng-template #hasOngoingOrOverdueStatus>
  <ng-container *ngFor="let invoice of invoicesByDate.invoices">
    <ng-container *ngIf="invoice.sliceDetail">
      <div class="rs-flex-row">
        <div class="rs-flex-column">
          <p class="rs-txt-details rs-padding-bottom1" data-cy="instalment">
            {{
              'bills.redesign.overview.balanceCard.sliceNumberDescription'
                | translate
            }}
            <strong>{{ invoice.sliceDetail[0].number }}</strong
            >/{{ sliceDetailsNumber }}
          </p>
        </div>
        <div class="rs-flex-column rs-flex-shrink">
          <p class="rs-font-pxB rs-padding-bottom1">
            <px-currency-amount
              [amount]="invoice.sliceDetail[0].amount"
            ></px-currency-amount>
          </p>
        </div>
      </div>
    </ng-container>
    <div class="rs-flex-row">
      <div class="rs-flex-column">
        <p class="rs-txt-details rs-padding-bottom1">
          {{ invoice.invoiceTypeTranslation }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-font-pxB rs-padding-bottom1">
          <px-currency-amount
            *ngIf="invoice.sliceDetail"
            [amount]="invoice.totalAmount"
          ></px-currency-amount>
          <px-currency-amount
            *ngIf="!invoice.sliceDetail"
            [amount]="invoice.amount"
          ></px-currency-amount>
        </p>
      </div>
    </div>
  </ng-container>
  <div class="rs-me"></div>
</ng-template>
